import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { navbarScroll } from '@app/core/utils/helpers';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [RouterLink, RouterLinkActive],
})
export class HeaderComponent {
  lastScrollY = 0;
  scrollDirection = 'up';
  @ViewChild('navbarToggler', { static: true }) navbarToggler: any;
  navigations = [
    {
      name: 'Overview',
      url: '/',
    },
    {
      name: 'Products',
      url: '/products',
    },
    {
      name: 'How It Works',
      url: '/how-it-works',
    },
    {
      name: 'Pricing',
      url: '/pricing',
    },
    // {
    //   name: 'Support',
    //   url: '/support',
    // },
  ];

  constructor() {
    navbarScroll();
  }

  resetToHome() {
    if (!this.navbarToggler.nativeElement.classList.contains('collapsed')) {
      this.navbarToggler.nativeElement.click();
    }
  }

  goToUrl(url: string) {
    if (!this.navbarToggler.nativeElement.classList.contains('collapsed')) {
      this.navbarToggler.nativeElement.click();
    }
    window.open(url, '_blank');
  }
}
